import React from "react"
import { IconColorsType } from "../"
import { camelize } from "../../utils"
import cx from "classnames"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "calendarStart"
const CalendarStartIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    }
  )
  const wrap = (content: React.ReactNode) => (
    <span className={computedClassName}>{content}</span>
  )
  return wrap(
    <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21 4v15c0 1.11-.893 2-1.995 2H4.995A1.997 1.997 0 0 1 3 19V4h18ZM4.995 8.001h.002C4.998 8 5 7.999 5 8h-.005Zm14.005 0v11H5V8h14Zm0 0h.005H19Zm-14 11h-.005H5Zm14 0h.005-.002c-.001 0-.003.002-.003 0ZM7 14v-4h4v4H7Z"
      />
    </svg>
  )
}
export default CalendarStartIcon
